import { Event } from "./event";

export function Subject(initialValue: any, name: string) {
    var self = this;
    var onChange = new Event();

    self.value = initialValue;

    self.asObservable = () => self;

    self.subscribe = (handler, hname: string) => {
        var binding = onChange.add(handler, name + "." + hname);
        var v = self.value;
        onChange.run(handler, v);
        return binding;
    };

    self.next = (newValue: any) => {
        self.value = newValue;
        onChange.dispatch(newValue);
    };
}
